import axios from "axios";
import qs from "qs";
const initialState = {
    globalArticles: [],
    globalArticleCount: 0,
};
export const state = { ...initialState };
export const actions = {

    async loadGlobalArticles(context,params){
        return axios.get("/api/global/articles",{params: params,
        paramsSerializer(params){
            var result = qs.stringify(params,{arrayFormat: "brackets"});
            return result
            }
        }).then(function(response){
        	console.log("from server",response)
            context.commit("setGlobalArticles",response.data.articles);
            context.commit("setGlobalArticleCount",response.data.count);
        })
    },
    async loadMoreGlobalArticles(context,params){
        return axios.get("/api/global/articles",{params: params,
        paramsSerializer(params){
            var result = qs.stringify(params,{arrayFormat: "brackets"});
            return result
            }
        }).then(function(response){
            context.commit("appendGlobalArticles",response.data.articles);
            context.commit("setGlobalArticleCount",response.data.count);

        })
    },

}

export const mutations = {



    setGlobalArticles(state, data){
        state.globalArticles = data;
    },

    setGlobalArticleCount(state,data){
        state.globalArticleCount = data;
    },

    appendGlobalArticles(state,data){
        state.globalArticles = state.globalArticles.concat(data);
    },

}

const getters = {
    globalArticles(state){
        return state.globalArticles;
    },
    globalArticleCount(state){
    	return state.globalArticleCount
    },
};

export default {
    state,
    actions,
    mutations,
    getters
  };
